/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../Form";
import useForm from "../../hooks/useForm";
import Modal, { ModalHeader } from "../Modal";
import systemAlert from "../../utils/systemAlert";
import { addInquiry, modifyInquiry } from "../../apis/admin/inquiry";

const defaultForm = {
  title: '',
  contents: ''
}

const Inquiry = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create')

  useEffect(() => {
    setFields([
      [
        {
          title: "신청자",
          key: "user.name",
          type: "text",
        },
        {
          title: "아이디",
          key: "user.id",
          type: "text",

        },
      ],
      [
        {
          title: "연락처",
          key: "user.mobile",
          type: "text",
        },
        {
          title: "이메일",
          key: "user.email",
          type: "text",
          validators: ['email'],

        },
      ],
      [
        {
          title: "제목",
          key: "title",
          type: "input",
          required: true,
        },
      ],
      [
        {
          title: "내용",
          key: "content",
          type: "textarea",
        },
      ],
      [
        {
          title: "답변",
          key: "answer",
          type: "textarea",
        },
      ],
      // [
      //   {
      //     title: "상태",
      //     isHide: () => {
      //       return mode === "create"
      //     },
      //     key: "state",
      //     type: "select",
      //     options: {
      //       list: ANSWERED_STATUS,
      //     },
      //   },
      // ],
    ])
  }, [mode])

  useEffect(() => {
    setValidateFields(fields)
    setMode(selectedItem ? 'detail' : 'create')
    if (selectedItem) {
      setForm({ ...selectedItem })
      setOriginForm({ ...selectedItem })
    } else {
      const defaultFormData = {
        ...defaultForm,
      }
      setForm(defaultFormData);
      setOriginForm(defaultFormData)
    }
  }, [open, selectedItem]);

  const _submit = (form) => {
    if (mode === "create") {
      systemAlert(`"${form.title}" 1:1 문의를 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              addInquiry(form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    } else {
      systemAlert(`"${form.title}" 1:1 문의를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              modifyInquiry(selectedItem.idx, {
                title: form.title,
                content: form.content,
                fileIdxes: form.fileIdxes,
                answer: form.answer,
                state: form.state,
              })
                .then(() => {
                  cancel();
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    //console.log(form)
  }, [form])

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null)
    }
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>{selectedItem && <>"{selectedItem.title}"</>} 1:1 문의 {mode === "create" ? "하기" : "수정"}</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '작성완료' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default Inquiry;
